import { useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Box, Checkbox, Typography, Grid } from "@mui/material";

import * as yup from "yup";
import { useFormik } from "formik";
import CommonButton from "../../../shared-components/common-button/CommonButton";
import CorporatePaymentOptionsForm from "./CorporatePaymentOptionsForm";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import {
  CorporateFinanceStatus,
  CorporatePaymentMode,
} from "../../../config/constant";
import { useTranslation } from "react-i18next";
import TextFieldInput from "../../../components/TextFieldInput";
import {
  setActiveStep,
  updatePaymentDetails,
  setEditPreviewApplicant,
  getApplicantDetails,
  setShowSaveAndPreview,
} from "../new-booking-form.slice";
import {
  convertNumberToWords,
  getLastStep,
} from "../../../utilis/common-funtions";
import { formatNumberIndian } from "../../../utilis/common-funtions";
import { route } from "../../../services/apiRoutes";
import {
  NewPaymentbuildPayload,
  setFormValuesFromApplicantData,
} from "./NewPaymentCommonFunction";
import ExcessAmountModal from "../../../shared-components/amount-popups/ExcessAmountModal";

const CorporatePaymentOption = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "corporatePaymentOption",
  });
  const { oppId } = useParams();
  const history = useHistory();

  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const [amountOpenModal, setOpenAmountModal] = useState(false);
  const [lessPaidAmount, setLessPaidAmount] = useState(false);

  const {
    applicantData,
    activeStep,
    isLoading,
    isUpgradePreferentialStep,
    enquiryDetails,
  } = useSelector((state) => state?.newBookingForm);
  const TOTAL_BOOKING_AMOUNT =
    enquiryDetails?.data?.BookingAmountAsPerAgreement;

  const paymentOptionsFormik = useFormik({
    initialValues: {
      amountInWords: convertNumberToWords(TOTAL_BOOKING_AMOUNT),
      totalAgreementValue: TOTAL_BOOKING_AMOUNT,
    },
    validationSchema: yup.object().shape({
      // Radio button
      // Cancellation/Refund shared fields across all payment methods
    }),
    onSubmit: (values) => { },
  });
  const MultipaymentOptionsFormik = useFormik({
    initialValues: {
      transactions: [
        {
          id: "",
          paymentMethod: CorporatePaymentMode.GATEWAY, // Online | Offline
          offlineRadioOptions: "",
          bankName: "",
          branchName: "",
          accountNo: "",
          amount: "",
          onlineAmount: TOTAL_BOOKING_AMOUNT,
          paymentProof: [],
          status: CorporateFinanceStatus.UNVERIFIED,
          date: null,
          type: "",
          isPaid: false,
          showUploadPopup: false,
          isPhysicalPaymentProof: false,
          email: "",
          onlineMethod: "",
          contact: "",
          orderId: "",
          gatewayPaymentId: "",
          paymentTransactionId: "",
          paidAmount: "",
        },
      ],
    },

    validationSchema: yup.object().shape({
      transactions: yup.array().of(
        yup.object().shape({
          paymentMethod: yup
            .string()
            .required(t("corporatePaymentValidations.paymentMethod")),

          // Always required
          // onlineAmount: yup
          //   .number()
          //   .typeError(t("corporatePaymentValidations.onlineAmount.typeError"))
          //   .required(t("corporatePaymentValidations.onlineAmount.required"))
          //   .moreThan(
          //     0,
          //     t("corporatePaymentValidations.onlineAmount.moreThan")
          //   ),

          amount: yup
            .number()
            .typeError(t("corporatePaymentValidations.amount.typeError"))
            .required(t("corporatePaymentValidations.amount.required"))
            .moreThan(0, t("corporatePaymentValidations.amount.moreThan")),

          isPaid: yup.boolean().when("paymentMethod", {
            is: CorporatePaymentMode.GATEWAY,
            then: (schema) =>
              schema.oneOf(
                [true],
                t("corporatePaymentValidations.isPaid.required")
              ),
            otherwise: (schema) => schema.notRequired(),
          }),

          // Offline-specific validations
          offlineRadioOptions: yup.string().when("paymentMethod", {
            is: CorporatePaymentMode.OFFLINE,
            then: (schema) =>
              schema.required(
                t("corporatePaymentValidations.offlineRadioOptions.required")
              ),
            otherwise: (schema) => schema.notRequired(),
          }),

          transactionNo: yup
            .string()
            .when(["paymentMethod", "offlineRadioOptions"], {
              is: (paymentMethod, offlineRadioOptions) =>
                paymentMethod === CorporatePaymentMode.OFFLINE &&
                offlineRadioOptions === "CHEQUE",
              then: (schema) =>
                schema
                  .required(
                    t(
                      "corporatePaymentValidations.transactionNumber.chequeRequired"
                    )
                  )
                  .matches(
                    /^\d{6}$/,
                    t(
                      "corporatePaymentValidations.transactionNumber.chequeInvalid"
                    )
                  ),
              otherwise: (schema) =>
                schema.when("paymentMethod", {
                  is: CorporatePaymentMode.OFFLINE,
                  then: (s) =>
                    s.required(
                      t(
                        "corporatePaymentValidations.transactionNumber.transactionRequired"
                      )
                    ),
                  otherwise: (s) => s.notRequired(),
                }),
            }),

          bankName: yup
            .string()
            .when(["paymentMethod", "offlineRadioOptions"], {
              is: (paymentMethod, offlineRadioOptions) =>
                paymentMethod === CorporatePaymentMode.OFFLINE &&
                offlineRadioOptions === "CHEQUE",
              then: (schema) =>
                schema.required(
                  t("corporatePaymentValidations.bankName.required")
                ),
              otherwise: (schema) => schema.notRequired(),
            }),

          branchName: yup.string().notRequired(),

          accountNo: yup.string().notRequired(),
          // If you want account number validation uncomment & map keys:
          // accountNo: yup.string().when("paymentMethod", {
          //   is: CorporatePaymentMode.OFFLINE,
          //   then: (schema) =>
          //     schema
          //       .matches(/^\d{9,}$/, t("validations.accountNumber.invalid"))
          //       .required(t("validations.accountNumber.required")),
          //   otherwise: (schema) => schema.notRequired(),
          // }),

          paymentProof: yup
            .array()
            .when(["paymentMethod", "isPhysicalPaymentProof"], {
              is: (paymentMethod, isPhysicalPaymentProof) =>
                paymentMethod === CorporatePaymentMode.OFFLINE &&
                isPhysicalPaymentProof === false,
              then: (schema) =>
                schema
                  .min(1, t("corporatePaymentValidations.paymentProof.min"))
                  .required(
                    t("corporatePaymentValidations.paymentProof.required")
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),

          date: yup.date().when("paymentMethod", {
            is: CorporatePaymentMode.OFFLINE,
            then: (schema) =>
              schema.required(t("corporatePaymentValidations.date.required")),
            otherwise: (schema) => schema.notRequired(),
          }),
        })
      ),
    }),

    onSubmit: (values) => {
      // dispatch API call or submit handler
    },
  });
  useEffect(() => {
    if (applicantData) {
      setFormValuesFromApplicantData(
        applicantData.paymentDetails,
        applicantData?.payments,
        MultipaymentOptionsFormik,
        paymentOptionsFormik
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData]);

  const handleSaveForm = async (isSaveandPreview = false) => {
    paymentOptionsFormik.validateForm();
    MultipaymentOptionsFormik.validateForm();
    await paymentOptionsFormik.submitForm();
    await MultipaymentOptionsFormik.submitForm();
    const sum = MultipaymentOptionsFormik.values.transactions?.reduce(
      (acc, txn) => acc + (Number(txn.amount) || 0),
      0
    );

    if (Object.keys(MultipaymentOptionsFormik.errors).length === 0) {
      if (
        TOTAL_BOOKING_AMOUNT &&
        sum &&
        Number(TOTAL_BOOKING_AMOUNT) > Number(sum) &&
        !lessPaidAmount
      ) {
        setLessPaidAmount(true);
        setOpenAmountModal(true);
        return;
      }
      setButtonLoading(true);
      try {
        await paymentOptionsFormik.submitForm();
        await MultipaymentOptionsFormik.submitForm();

        const payload = NewPaymentbuildPayload(
          MultipaymentOptionsFormik.values,
          false,
          applicantData?.bookingAs,
          paymentOptionsFormik?.values?.amountInWords,
          activeStep + 1,
          oppId
        );

        const res = await dispatch(updatePaymentDetails({ payload })).unwrap();
        if (res) {
          setLessPaidAmount(false);
          setOpenAmountModal(false);
          dispatch(setActiveStep(activeStep + 1));
          dispatch(getApplicantDetails(`/${oppId}`));
          dispatch(setShowSaveAndPreview(false))
          if (isSaveandPreview) {
            dispatch(setEditPreviewApplicant(false));
            history.push(`/customer-preview/${oppId}`);
          }
        }
        setButtonLoading(false);
      } catch (err) {
        setButtonLoading(false);

        setSnackBarconfig({
          open: true,
          message:
            err?.errors?.errors?.message || "Failed to update payment details.",
          severity: "error",
        });
        console.error("Failed to save payment details:", err);
      }
    }
  };

  useEffect(() => {
    paymentOptionsFormik.validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOptionsFormik?.values]);

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  // Helper function to create the other details payload

  useEffect(() => {
    paymentOptionsFormik.setErrors({});
    paymentOptionsFormik.setTouched({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOptionsFormik.values.paymentMethod]);

  // Function to build final payload

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleDeficientAmountModal = () => {
    setOpenAmountModal(false);
    setLessPaidAmount(false);
  };
  const handleContinuePayment = () => {
    handleSaveForm(false);
  };
  return (
    <div>
      {isLoading && <Loader isLoading={isLoading} />}

      <Typography
        sx={{
          color: "#1C252E",
          fontSize: "16px",
          fontWeight: "600",
          lineHeight: "36px",
          mb: "12px",
          textAlign: "center",
        }}
      >
        {t("heading")}
      </Typography>

      <form
        onSubmit={paymentOptionsFormik.handleSubmit}
        onReset={paymentOptionsFormik.handleReset}
        autoComplete="off"
      >
        <>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#1C252E",
              fontWeight: "500",
              lineHeight: "22px",
              mb: "6px",
            }}
          >
            {t("paymentMessage")}
            <span className="asteriskColor"> *</span>
          </Typography>
          <Grid container spacing={2} mb={3}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
              <TextFieldInput
                field={{
                  name: "totalAgreementValue",
                  label: "",
                  required: true,
                  readonly: true,
                }}
                formik={{
                  ...paymentOptionsFormik,
                  values: {
                    ...paymentOptionsFormik.values,
                    totalAgreementValue: paymentOptionsFormik.values
                      .totalAgreementValue
                      ? `₹ ${formatNumberIndian(
                        paymentOptionsFormik.values.totalAgreementValue
                      )}`
                      : "",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={8} md={8} lg={9} xl={9}>
              <TextFieldInput
                field={{
                  name: "amountInWords",
                  label: "",
                  required: true,
                  readonly: true,
                }}
                formik={paymentOptionsFormik}
              />
            </Grid>
          </Grid>
        </>

        <CorporatePaymentOptionsForm
          paymentOptionsFormik={MultipaymentOptionsFormik}
          totalAmount={Number(TOTAL_BOOKING_AMOUNT)}
        />

        {paymentOptionsFormik.touched.termsAndConditions &&
          paymentOptionsFormik.errors.termsAndConditions && (
            <Typography variant="caption" color="error">
              {paymentOptionsFormik.errors.termsAndConditions}
            </Typography>
          )}

        <CommonButton
          isSubmit
          handleNext={() => {
            handleSaveForm(false);
          }}
          // isDisable={isDisable}
          handlePrevious={handlePrevious}
          saveDraftPath={`${route.UPDATE_PAYMENT_DATA}`}
          saveDraftData={{
            ...NewPaymentbuildPayload(
              MultipaymentOptionsFormik.values,
              false,
              applicantData?.bookingAs,
              paymentOptionsFormik?.values?.amountInWords,
              getLastStep(applicantData?.lastStep, activeStep),
              oppId
            ),
          }}
          saveAndPreview={() => {
            handleSaveForm(true);
          }}
          buttonLoading={buttonLoading}
        />
        {amountOpenModal && (
          <ExcessAmountModal
            closePopup={handleDeficientAmountModal}
            handleExcessAmount={handleContinuePayment}
            message={
              "The amount you have entered is less than the booking amount. "
            }
          />
        )}

        <SnackbarAlert
          open={snackbarConfig.open}
          message={snackbarConfig.message}
          severity={snackbarConfig.severity}
          onClose={handleSnackbarClose}
        />
      </form>
    </div>
  );
};

export default CorporatePaymentOption;
